const mutations = {
  'SET_BUSINESSES_MONTHLY_STATES_TASK' (state, { businessesMonthlyStatesTask }) {
    state.businessesMonthlyStatesTask = businessesMonthlyStatesTask;
  }
}

export default mutations